var map = {
	"../pages/cases/cases.module": [
		"./src/app/pages/cases/cases.module.ts",
		"default~pages-cases-cases-module~pages-dashboard-dashboard-module~pages-kyc-details-kyc-details-modu~a93b9838",
		"default~pages-cases-cases-module~pages-dashboard-dashboard-module~pages-modem-password-modem-module~~e7494256",
		"common",
		"pages-cases-cases-module"
	],
	"../pages/dashboard/dashboard.module": [
		"./src/app/pages/dashboard/dashboard.module.ts",
		"default~pages-cases-cases-module~pages-dashboard-dashboard-module~pages-kyc-details-kyc-details-modu~a93b9838",
		"default~pages-cases-cases-module~pages-dashboard-dashboard-module~pages-modem-password-modem-module~~e7494256",
		"pages-dashboard-dashboard-module"
	],
	"../pages/modem-password/modem.module": [
		"./src/app/pages/modem-password/modem.module.ts",
		"default~pages-cases-cases-module~pages-dashboard-dashboard-module~pages-kyc-details-kyc-details-modu~a93b9838",
		"default~pages-cases-cases-module~pages-dashboard-dashboard-module~pages-modem-password-modem-module~~e7494256",
		"common",
		"pages-modem-password-modem-module"
	],
	"../pages/payments/payments.module": [
		"./src/app/pages/payments/payments.module.ts",
		"default~pages-cases-cases-module~pages-dashboard-dashboard-module~pages-kyc-details-kyc-details-modu~a93b9838",
		"default~pages-cases-cases-module~pages-dashboard-dashboard-module~pages-modem-password-modem-module~~e7494256",
		"common",
		"pages-payments-payments-module"
	],
	"../pages/plans/plans.module": [
		"./src/app/pages/plans/plans.module.ts",
		"default~pages-cases-cases-module~pages-dashboard-dashboard-module~pages-kyc-details-kyc-details-modu~a93b9838",
		"default~pages-cases-cases-module~pages-dashboard-dashboard-module~pages-modem-password-modem-module~~e7494256",
		"default~pages-kyc-details-kyc-details-module~pages-plans-plans-module~pages-sessions-sessions-module",
		"common",
		"pages-plans-plans-module"
	],
	"../pages/purchase-history-request/purchase-history-request.module": [
		"./src/app/pages/purchase-history-request/purchase-history-request.module.ts",
		"default~pages-cases-cases-module~pages-dashboard-dashboard-module~pages-kyc-details-kyc-details-modu~a93b9838",
		"default~pages-cases-cases-module~pages-dashboard-dashboard-module~pages-modem-password-modem-module~~e7494256",
		"common",
		"pages-purchase-history-request-purchase-history-request-module"
	],
	"../pages/purchase/purchase.module": [
		"./src/app/pages/purchase/purchase.module.ts",
		"default~pages-cases-cases-module~pages-dashboard-dashboard-module~pages-kyc-details-kyc-details-modu~a93b9838",
		"default~pages-cases-cases-module~pages-dashboard-dashboard-module~pages-modem-password-modem-module~~e7494256",
		"common",
		"pages-purchase-purchase-module"
	],
	"../pages/recharge/recharge.module": [
		"./src/app/pages/recharge/recharge.module.ts",
		"default~pages-cases-cases-module~pages-dashboard-dashboard-module~pages-kyc-details-kyc-details-modu~a93b9838",
		"default~pages-cases-cases-module~pages-dashboard-dashboard-module~pages-modem-password-modem-module~~e7494256",
		"default~layout-layout-module~pages-recharge-recharge-module",
		"common",
		"pages-recharge-recharge-module"
	],
	"../pages/selfcare-password/selfcare-password.module": [
		"./src/app/pages/selfcare-password/selfcare-password.module.ts",
		"default~pages-cases-cases-module~pages-dashboard-dashboard-module~pages-kyc-details-kyc-details-modu~a93b9838",
		"default~pages-cases-cases-module~pages-dashboard-dashboard-module~pages-modem-password-modem-module~~e7494256",
		"common",
		"pages-selfcare-password-selfcare-password-module"
	],
	"../pages/sessions/sessions.module": [
		"./src/app/pages/sessions/sessions.module.ts",
		"default~pages-cases-cases-module~pages-dashboard-dashboard-module~pages-kyc-details-kyc-details-modu~a93b9838",
		"default~pages-cases-cases-module~pages-dashboard-dashboard-module~pages-modem-password-modem-module~~e7494256",
		"default~pages-kyc-details-kyc-details-module~pages-plans-plans-module~pages-sessions-sessions-module",
		"common",
		"pages-sessions-sessions-module"
	],
	"../pages/update-profile/update-profile.module": [
		"./src/app/pages/update-profile/update-profile.module.ts",
		"default~pages-cases-cases-module~pages-dashboard-dashboard-module~pages-kyc-details-kyc-details-modu~a93b9838",
		"default~pages-cases-cases-module~pages-dashboard-dashboard-module~pages-modem-password-modem-module~~e7494256",
		"common",
		"pages-update-profile-update-profile-module"
	],
	"./layout/layout.module": [
		"./src/app/layout/layout.module.ts",
		"default~layout-layout-module~pages-recharge-recharge-module",
		"layout-layout-module"
	],
	"./pages/kyc-details/kyc-details.module": [
		"./src/app/pages/kyc-details/kyc-details.module.ts",
		"default~pages-cases-cases-module~pages-dashboard-dashboard-module~pages-kyc-details-kyc-details-modu~a93b9838",
		"default~pages-kyc-details-kyc-details-module~pages-plans-plans-module~pages-sessions-sessions-module",
		"pages-kyc-details-kyc-details-module"
	],
	"./pages/login/login.module": [
		"./src/app/pages/login/login.module.ts",
		"pages-login-login-module"
	],
	"./pages/register/register.module": [
		"./src/app/pages/register/register.module.ts",
		"pages-register-register-module"
	],
	"./pages/reset-password/reset-password.module": [
		"./src/app/pages/reset-password/reset-password.module.ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;